import React from 'react';
import PropTypes from 'prop-types';

import DialogContent from '@material-ui/core/DialogContent';
import { DialogActions } from '@material-ui/core';
import { FormattedMessageWrappedInSpan } from '../../misc';

import CustomDialog from './CustomDialog';

const HowToUseThatsMeDialog = ({
  open,
  onRequestClose,
  onGoBackToMainSearch,
  eventHasSearchByFace,
}) => {
  return (
    <CustomDialog open={open} onRequestClose={onRequestClose}>
      <div className="notification-container">
        <DialogContent>
          <div className="notification-body">
            <h1>
              {eventHasSearchByFace ? (
                <FormattedMessageWrappedInSpan
                  id="howToUseThatsMeDialog.title.faceSearch"
                  defaultMessage="Use face search to tag photos"
                />
              ) : (
                <FormattedMessageWrappedInSpan
                  id="howToUseThatsMeDialog.title.bibSerach"
                  defaultMessage="Use bib number search to tag photos"
                />
              )}
            </h1>
            {eventHasSearchByFace ? (
              <FormattedMessageWrappedInSpan
                id="howToUseThatsMeDialog.instruction.faceSearch"
                defaultMessage="Tagging photos is currently disabled. To enable it, use face search first."
              />
            ) : (
              <FormattedMessageWrappedInSpan
                id="howToUseThatsMeDialog.instruction.bibSearch"
                defaultMessage="Tagging photos is currently disabled. To enable it, use bib search first."
              />
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <div className="notification-action">
            <button onClick={onRequestClose}>
              <FormattedMessageWrappedInSpan
                id="howToUseThatsMeDialog.acceptButton"
                defaultMessage="OK"
              />
            </button>
            {onGoBackToMainSearch && (
              <button className="accept" onClick={onGoBackToMainSearch}>
                {eventHasSearchByFace ? (
                  <FormattedMessageWrappedInSpan
                    id="howToUseThatsMeDialog.backToMainSearch.faceSearch"
                    defaultMessage="Go to face search"
                  />
                ) : (
                  <FormattedMessageWrappedInSpan
                    id="howToUseThatsMeDialog.backToMainSearch.bibSearch"
                    defaultMessage="Go to bib number search"
                  />
                )}
              </button>
            )}
          </div>
        </DialogActions>
      </div>
    </CustomDialog>
  );
};

HowToUseThatsMeDialog.propTypes = {
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
  onGoBackToMainSearch: PropTypes.func,
  eventHasSearchByFace: PropTypes.bool,
};

export default HowToUseThatsMeDialog;
